import React, { Component } from 'react';

class NotFoundPage extends Component {


    render() {
        return (
          <div className="not-found-page">
            <h1 className="not-found-title">NOT FOUND, SORRY</h1>
          </div>
        );
    }
}

export default NotFoundPage;
